import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo } from 'react';
import { FlexContainer } from '../../CSS/index.js';
import { TextButton } from '../../Button/index.js';
import { IconUIElement } from '../../Icon/index.js';
export const ErrorFallbackActionsGroup = memo(props => {
    const { navigation } = props;
    function handleLinkClick(link) {
        window.location.replace(link);
    }
    return (_jsxs(FlexContainer, { cy: "error-fallback-actions", as: "section", style: {
            justifyContent: 'center',
            alignItems: 'center',
            padding: '25px 0',
            '& button span': {
                width: 20
            },
            '& button a': {
                color: 'inherit',
                textDecoration: 'none'
            }
        }, children: [navigation && (_jsx(TextButton, { cy: "error-fallback-additional-navigation", icon: _jsx(IconUIElement.ArrowLong, {}), onClick: () => handleLinkClick(navigation.route), children: navigation.text })), _jsx(TextButton, { cy: "error-fallback-contact-us", icon: _jsx(IconUIElement.ArrowLong, {}), children: _jsx("a", { href: "mailto:support@astrumu.com", children: "contact support" }) })] }));
});
//# sourceMappingURL=index.js.map